import { t } from '@lingui/macro';

import RPHeroATDesktop from '@rover/react-lib/src/images/homepage/rover-protect/AT/RPHeroATDesktop.webp';
import RPHeroATMobile from '@rover/react-lib/src/images/homepage/rover-protect/AT/RPHeroATMobile.webp';
import RPRoverCardPreviewAT from '@rover/react-lib/src/images/homepage/rover-protect/AT/RPRoverCardPreviewAT.webp';
import RPSearchCardAT from '@rover/react-lib/src/images/homepage/rover-protect/AT/RPSearchCardAT.webp';
import RPHeroBEDesktop from '@rover/react-lib/src/images/homepage/rover-protect/BE/RPHeroBEDesktop.webp';
import RPHeroBEMobile from '@rover/react-lib/src/images/homepage/rover-protect/BE/RPHeroBEMobile.webp';
import RPRoverCardPreviewBE from '@rover/react-lib/src/images/homepage/rover-protect/BE/RPRoverCardPreviewBE.webp';
import RPSearchCardBE from '@rover/react-lib/src/images/homepage/rover-protect/BE/RPSearchCardBE.webp';
import RPHeroBEFRDesktop from '@rover/react-lib/src/images/homepage/rover-protect/BE_FR/RPHeroBEFRDesktop.webp';
import RPHeroBEFRMobile from '@rover/react-lib/src/images/homepage/rover-protect/BE_FR/RPHeroBEFRMobile.webp';
import RPRoverCardPreviewBEFR from '@rover/react-lib/src/images/homepage/rover-protect/BE_FR/RPRoverCardPreviewBEFR.webp';
import RPSearchCardBEFR from '@rover/react-lib/src/images/homepage/rover-protect/BE_FR/RPSearchCardBEFR.webp';
import RPSearchCardENCA from '@rover/react-lib/src/images/homepage/rover-protect/CA_EN/RPSearchCardENCA.webp';
import RPSearchCardFRCA from '@rover/react-lib/src/images/homepage/rover-protect/CA_FR/RPSearchCardFRCA.webp';
import RPHeroCHDesktop from '@rover/react-lib/src/images/homepage/rover-protect/CH/RPHeroCHDesktop.webp';
import RPHeroCHMobile from '@rover/react-lib/src/images/homepage/rover-protect/CH/RPHeroCHMobile.webp';
import RPRoverCardPreviewCH from '@rover/react-lib/src/images/homepage/rover-protect/CH/RPRoverCardPreviewCH.webp';
import RPSearchCardCH from '@rover/react-lib/src/images/homepage/rover-protect/CH/RPSearchCardCH.webp';
import RPHeroCHFRDesktop from '@rover/react-lib/src/images/homepage/rover-protect/CH_FR/RPHeroCHFRDesktop.webp';
import RPHeroCHFRMobile from '@rover/react-lib/src/images/homepage/rover-protect/CH_FR/RPHeroCHFRMobile.webp';
import RPRoverCardPreviewCHFR from '@rover/react-lib/src/images/homepage/rover-protect/CH_FR/RPRoverCardPreviewCHFR.webp';
import RPSearchCardCHFR from '@rover/react-lib/src/images/homepage/rover-protect/CH_FR/RPSearchCardCHFR.webp';
import RPHeroCHITDesktop from '@rover/react-lib/src/images/homepage/rover-protect/CH_IT/RPHeroCHITDesktop.webp';
import RPHeroCHITMobile from '@rover/react-lib/src/images/homepage/rover-protect/CH_IT/RPHeroCHITMobile.webp';
import RPRoverCardPreviewCHIT from '@rover/react-lib/src/images/homepage/rover-protect/CH_IT/RPRoverCardPreviewCHIT.webp';
import RPSearchCardCHIT from '@rover/react-lib/src/images/homepage/rover-protect/CH_IT/RPSearchCardCHIT.webp';
import RPHeroDEDesktop from '@rover/react-lib/src/images/homepage/rover-protect/DE/RPHeroDEDesktop.webp';
import RPHeroDEMobile from '@rover/react-lib/src/images/homepage/rover-protect/DE/RPHeroDEMobile.webp';
import RPRoverCardPreviewDE from '@rover/react-lib/src/images/homepage/rover-protect/DE/RPRoverCardPreviewDE.webp';
import RPSearchCardDE from '@rover/react-lib/src/images/homepage/rover-protect/DE/RPSearchCardDE.webp';
import RPHeroDKDesktop from '@rover/react-lib/src/images/homepage/rover-protect/DK/RPHeroDKDesktop.webp';
import RPHeroDKMobile from '@rover/react-lib/src/images/homepage/rover-protect/DK/RPHeroDKMobile.webp';
import RPRoverCardPreviewDK from '@rover/react-lib/src/images/homepage/rover-protect/DK/RPRoverCardPreviewDK.webp';
import RPSearchCardDK from '@rover/react-lib/src/images/homepage/rover-protect/DK/RPSearchCardDK.webp';
import RPHeroESDesktop from '@rover/react-lib/src/images/homepage/rover-protect/ES/RPHeroESDesktop.jpg';
import RPHeroESMobile from '@rover/react-lib/src/images/homepage/rover-protect/ES/RPHeroESMobile.jpg';
import RPRoverCardPreviewES from '@rover/react-lib/src/images/homepage/rover-protect/ES/RPRoverCardPreviewES.png';
import RPSearchCardES from '@rover/react-lib/src/images/homepage/rover-protect/ES/RPSearchCardES.jpg';
import RPHeroFIDesktop from '@rover/react-lib/src/images/homepage/rover-protect/FI/RPHeroFIDesktop.webp';
import RPHeroFIMobile from '@rover/react-lib/src/images/homepage/rover-protect/FI/RPHeroFIMobile.webp';
import RPRoverCardPreviewFI from '@rover/react-lib/src/images/homepage/rover-protect/FI/RPRoverCardPreviewFI.webp';
import RPSearchCardFI from '@rover/react-lib/src/images/homepage/rover-protect/FI/RPSearchCardFI.webp';
import RPHeroFRDesktop from '@rover/react-lib/src/images/homepage/rover-protect/FR/RPHeroFRDesktop.webp';
import RPHeroFRMobile from '@rover/react-lib/src/images/homepage/rover-protect/FR/RPHeroFRMobile.webp';
import RPRoverCardPreviewFR from '@rover/react-lib/src/images/homepage/rover-protect/FR/RPRoverCardPreviewFR.webp';
import RPSearchCardFRFR from '@rover/react-lib/src/images/homepage/rover-protect/FR/RPSearchCardFRFR.webp';
import HeroImg from '@rover/react-lib/src/images/homepage/rover-protect/HeroImg.webp';
import HeroImgMob from '@rover/react-lib/src/images/homepage/rover-protect/HeroImgMob.webp';
import RPRoverCardPreviewIE from '@rover/react-lib/src/images/homepage/rover-protect/IE/RPRoverCardPreviewIE.webp';
import RPSearchCardIE from '@rover/react-lib/src/images/homepage/rover-protect/IE/RPSearchCardIE.webp';
import RPHeroITDesktop from '@rover/react-lib/src/images/homepage/rover-protect/IT/RPHeroITDesktop.webp';
import RPHeroITMobile from '@rover/react-lib/src/images/homepage/rover-protect/IT/RPHeroITMobile.webp';
import RPRoverCardPreviewIT from '@rover/react-lib/src/images/homepage/rover-protect/IT/RPRoverCardPreviewIT.webp';
import RPSearchCardIT from '@rover/react-lib/src/images/homepage/rover-protect/IT/RPSearchCardIT.webp';
import RPHeroNLDesktop from '@rover/react-lib/src/images/homepage/rover-protect/NL/RPHeroNLDesktop.webp';
import RPHeroNLMobile from '@rover/react-lib/src/images/homepage/rover-protect/NL/RPHeroNLMobile.webp';
import RPRoverCardPreviewNL from '@rover/react-lib/src/images/homepage/rover-protect/NL/RPRoverCardPreviewNL.webp';
import RPSearchCardNL from '@rover/react-lib/src/images/homepage/rover-protect/NL/RPSearchCardNL.webp';
import RPHeroNODesktop from '@rover/react-lib/src/images/homepage/rover-protect/NO/RPHeroNODesktop.webp';
import RPHeroNOMobile from '@rover/react-lib/src/images/homepage/rover-protect/NO/RPHeroNOMobile.webp';
import RPRoverCardPreviewNO from '@rover/react-lib/src/images/homepage/rover-protect/NO/RPRoverCardPreviewNO.webp';
import RPSearchCardNO from '@rover/react-lib/src/images/homepage/rover-protect/NO/RPSearchCardNO.webp';
import RPHeroPLDesktop from '@rover/react-lib/src/images/homepage/rover-protect/PL/RPHeroPLDesktop.webp';
import RPHeroPLMobile from '@rover/react-lib/src/images/homepage/rover-protect/PL/RPHeroPLMobile.webp';
import RPRoverCardPreviewPL from '@rover/react-lib/src/images/homepage/rover-protect/PL/RPRoverCardPreviewPL.webp';
import RPSearchCardPL from '@rover/react-lib/src/images/homepage/rover-protect/PL/RPSearchCardPL.webp';
import RPHeroPTDesktop from '@rover/react-lib/src/images/homepage/rover-protect/PT/RPHeroPTDesktop.webp';
import RPHeroPTMobile from '@rover/react-lib/src/images/homepage/rover-protect/PT/RPHeroPTMobile.webp';
import RPRoverCardPreviewPT from '@rover/react-lib/src/images/homepage/rover-protect/PT/RPRoverCardPreviewPT.webp';
import RPSearchCardPT from '@rover/react-lib/src/images/homepage/rover-protect/PT/RPSearchCardPT.png';
import RPRoverCardPreviewUS from '@rover/react-lib/src/images/homepage/rover-protect/RPRoverCardPreviewUS.webp';
import RPHeroSEDesktop from '@rover/react-lib/src/images/homepage/rover-protect/SE/RPHeroSEDesktop.webp';
import RPHeroSEMobile from '@rover/react-lib/src/images/homepage/rover-protect/SE/RPHeroSEMobile.webp';
import RPRoverCardPreviewSE from '@rover/react-lib/src/images/homepage/rover-protect/SE/RPRoverCardPreviewSE.webp';
import RPSearchCardSE from '@rover/react-lib/src/images/homepage/rover-protect/SE/RPSearchCardSE.webp';
import SitterCard2 from '@rover/react-lib/src/images/homepage/rover-protect/SitterCard2.webp';
import TestimonialImg1 from '@rover/react-lib/src/images/homepage/rover-protect/TestimonialImg1.png';
import TestimonialImg2 from '@rover/react-lib/src/images/homepage/rover-protect/TestimonialImg2.png';
import TestimonialImg3 from '@rover/react-lib/src/images/homepage/rover-protect/TestimonialImg3.png';
import RPRoverCardPreviewUKCA from '@rover/react-lib/src/images/homepage/rover-protect/UK/RPRoverCardPreviewUKCA.webp';
import RPSearchCardENUK from '@rover/react-lib/src/images/homepage/rover-protect/UK/RPSearchCardENUK.webp';

import { CarouselData } from './components/Carousel';

// utils for LandingSection.tsx
export const getDesktopHeroImg = (language): string => {
  switch (language) {
    case 'de-de':
      return RPHeroDEDesktop;
    case 'da-dk':
      return RPHeroDKDesktop;
    case 'es-es':
      return RPHeroESDesktop;
    case 'fr-fr':
    case 'fr-ca':
      return RPHeroFRDesktop;
    case 'it-it':
      return RPHeroITDesktop;
    case 'nl-nl':
      return RPHeroNLDesktop;
    case 'nb-no':
      return RPHeroNODesktop;
    case 'sv-se':
      return RPHeroSEDesktop;
    case 'de-at':
      return RPHeroATDesktop;
    case 'de-ch':
      return RPHeroCHDesktop;
    case 'fr-ch':
      return RPHeroCHFRDesktop;
    case 'it-ch':
      return RPHeroCHITDesktop;
    case 'nl-be':
      return RPHeroBEDesktop;
    case 'fr-be':
      return RPHeroBEFRDesktop;
    case 'fi-fi':
      return RPHeroFIDesktop;
    case 'pl-pl':
      return RPHeroPLDesktop;
    case 'pt-pt':
      return RPHeroPTDesktop;
    default:
      return HeroImg;
  }
};

export const getMobileHeroImg = (language): string => {
  switch (language) {
    case 'de-de':
      return RPHeroDEMobile;
    case 'da-dk':
      return RPHeroDKMobile;
    case 'es-es':
      return RPHeroESMobile;
    case 'fr-fr':
    case 'fr-ca':
      return RPHeroFRMobile;
    case 'it-it':
      return RPHeroITMobile;
    case 'nl-nl':
      return RPHeroNLMobile;
    case 'nb-no':
      return RPHeroNOMobile;
    case 'sv-se':
      return RPHeroSEMobile;
    case 'de-at':
      return RPHeroATMobile;
    case 'de-ch':
      return RPHeroCHMobile;
    case 'fr-ch':
      return RPHeroCHFRMobile;
    case 'it-ch':
      return RPHeroCHITMobile;
    case 'nl-be':
      return RPHeroBEMobile;
    case 'fr-be':
      return RPHeroBEFRMobile;
    case 'fi-fi':
      return RPHeroFIMobile;
    case 'pl-pl':
      return RPHeroPLMobile;
    case 'pt-pt':
      return RPHeroPTMobile;
    default:
      return HeroImgMob;
  }
};

// utils for FourPillarsSection.tsx
export const getSearchCard = (language): string => {
  switch (language) {
    case 'de-de':
      return RPSearchCardDE;
    case 'da-dk':
      return RPSearchCardDK;
    case 'en-ie':
      return RPSearchCardIE;
    case 'es-es':
      return RPSearchCardES;
    case 'fr-fr':
      return RPSearchCardFRFR;
    case 'fr-ca':
      return RPSearchCardFRCA;
    case 'en-ca':
      return RPSearchCardENCA;
    case 'it-it':
      return RPSearchCardIT;
    case 'nl-nl':
      return RPSearchCardNL;
    case 'nb-no':
      return RPSearchCardNO;
    case 'sv-se':
      return RPSearchCardSE;
    case 'en-gb':
      return RPSearchCardENUK;
    case 'de-at':
      return RPSearchCardAT;
    case 'de-ch':
      return RPSearchCardCH;
    case 'fr-ch':
      return RPSearchCardCHFR;
    case 'it-ch':
      return RPSearchCardCHIT;
    case 'nl-be':
      return RPSearchCardBE;
    case 'fr-be':
      return RPSearchCardBEFR;
    case 'fi-fi':
      return RPSearchCardFI;
    case 'pl-pl':
      return RPSearchCardPL;
    case 'pt-pt':
      return RPSearchCardPT;
    default:
      return SitterCard2;
  }
};

export const getRoverCard = (language): string => {
  switch (language) {
    case 'de-de':
      return RPRoverCardPreviewDE;
    case 'da-dk':
      return RPRoverCardPreviewDK;
    case 'en-ie':
      return RPRoverCardPreviewIE;
    case 'es-es':
      return RPRoverCardPreviewES;
    case 'fr-fr':
    case 'fr-ca':
      return RPRoverCardPreviewFR;
    case 'it-it':
      return RPRoverCardPreviewIT;
    case 'nl-nl':
      return RPRoverCardPreviewNL;
    case 'nb-no':
      return RPRoverCardPreviewNO;
    case 'sv-se':
      return RPRoverCardPreviewSE;
    case 'en-gb':
    case 'en-ca':
      return RPRoverCardPreviewUKCA;
    case 'de-at':
      return RPRoverCardPreviewAT;
    case 'de-ch':
      return RPRoverCardPreviewCH;
    case 'fr-ch':
      return RPRoverCardPreviewCHFR;
    case 'it-ch':
      return RPRoverCardPreviewCHIT;
    case 'nl-be':
      return RPRoverCardPreviewBE;
    case 'fr-be':
      return RPRoverCardPreviewBEFR;
    case 'fi-fi':
      return RPRoverCardPreviewFI;
    case 'pl-pl':
      return RPRoverCardPreviewPL;
    case 'pt-pt':
      return RPRoverCardPreviewPT;
    default:
      return RPRoverCardPreviewUS;
  }
};

// utils for TestimonialsSection.tsx
export const getCarouselData = (): CarouselData[] => {
  return [
    {
      src: TestimonialImg1,
      description: t`Picture of woman holding dog`,
      comment: t`My sitter was very sweet and attentive! I knew she spent a lot of time with my boys and she stayed in touch like I like. She cleaned my bulldog's eyes and put drops in them and gave them yummy treats. I felt extremely safe having her take care of them. Thank you!`,
    },
    {
      src: TestimonialImg2,
      description: t`Picture of person taking picture of dog`,
      comment: t`Excellent! I had no worries! My sitter provided photos & let me know how my dog was doing throughout his stay. She showed a genuine concern for my pet's safety, comfort, and happiness.`,
    },
    {
      src: TestimonialImg3,
      description: t`Picture of dog sniffing a hand`,
      comment: t`My sitters were kind, caring, and very conscientious. Our senior dog was much loved and doted on and her stay couldn't have been better. They provided a quiet and safe environment for her and their communication with notes and photos throughout her visit were also much appreciated. Highly recommend.`,
    },
  ];
};

// widths for sections
export const widthArray = ['100%', '750px', '970px', '1170px'];
